import utils from 'utils'
import redFromPage from './view/selectTicket.html'
import billTemplate from './view/billModal.html'
import synchronousTemplate from './view/synchronousModal.html'
export default function selectTicket($uibModal, httpRequest, logger, STFieldConfig, $filter, Upload) {
    return {
        restrict: 'E',
        scope: {
            changeState: '=',
            confirmSheetState: '<',
            selectedRows: '<',
        },
        template: redFromPage,
        controller: [
            '$scope',
            '$location',
            'initSortService',
            'dictService',
            '$uibModal',
            ($scope, $location, initSortService, dictService, $uibModal) => {
                $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
                // const aMonth = utils.genPeriodByMonth()
                const nowDate = new Date()
                const aMonth = {
                    start: $filter('date')(nowDate, 'yyyy-MM-01'),
                    end:$filter('date')(nowDate, 'yyyy-MM-dd'),
                }
                $scope.gfShow = true
                $scope.xfShow = false
                $scope.queryParam = {
                    pageNum: 1,
                    pageSize: 10,
                    param: {
                        invoiceDateStart: aMonth.start,
                        invoiceDateEnd: aMonth.end,
                        invoiceSource:'0',
                        collection: '1',
                        invoiceType:'61',
                        invoiceTypeList:[],
                        invoiceStatus:'',
                        invoiceStatusList:[],
                        ukeyId: $scope.ukeyList[0].ukeyId,
                    },
                }
                $scope.profileType = '211'
                $scope.dictData = {}
                $scope.dictData.invoice_type = [
                    {
                        enumCode: '2',
                        enumName: '纸质普通发票',
                    },
                    {
                        enumCode: '0',
                        enumName: '纸质专用发票',
                    },
                    {
                        enumCode: '51',
                        enumName: '电子普通发票',
                    },
                    {
                        enumCode: '52',
                        enumName: '电子专用发票',
                    },
                    {
                        enumCode: '61',
                        enumName: '全电电子普票',
                    },
                    {
                        enumCode: '62',
                        enumName: '全电电子专票',
                    },
                ]
                $scope.dictData.status_type = [
                    {
                        enumCode: '1',
                        enumName: '正常',
                    },
                    {
                        enumCode: '4',
                        enumName: '部分红冲',
                    },
                ]
                $scope.dictData.invoice_status = [
                    {
                        enumCode: '01',
                        enumName: '正常',
                    },
                    {
                        enumCode: '04',
                        enumName: '部分红冲',
                    },
                ]
                const dictTypeArr = ['red_confirm_collection', 'red_confirm_invoice_source', 'all_special_invoice_status','invoice_source']
                httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res) => {
                    $scope.dictData = $.extend($scope.dictData, res.data.value)
                })
                $scope.reset = function () {
                    $scope.queryParam.param.ukeyId = $scope.ukeyList[0].ukeyId
                    $scope.ukeyChange()
                    if($scope.manageType=='7'){ //乐企平台
                        $scope.queryParam = {
                            pageNum: 1,
                            pageSize: 10,
                            param: {
                                invoiceDateStart: aMonth.start,
                                invoiceDateEnd: aMonth.end,
                                invoiceSource:'',
                                collection: '1',
                                ukeyId: $scope.ukeyList[0].ukeyId,
                                invoiceType:'',
                                invoiceTypeList:[''],
                                invoiceStatus:'',
                                invoiceStatusList:[''],
                            },
                        }
                    }else {
                        $scope.queryParam = {
                            pageNum: 1,
                            pageSize: 10,
                            param: {
                                invoiceDateStart: aMonth.start,
                                invoiceDateEnd: aMonth.end,
                                invoiceSource:'0',
                                collection: '1',
                                ukeyId: $scope.ukeyList[0].ukeyId,
                                invoiceType:'61',
                                invoiceTypeList:['61'],
                                invoiceStatus:'',
                                invoiceStatusList:[''],
                            },
                        }
                    }
                }
                $scope.ukeyChange = function ukeyChange() {
                    const newUkeyListArr = $scope.ukeyList.filter((item) => item.ukeyId === $scope.queryParam.param.ukeyId)
                    $scope.manageType = newUkeyListArr[0].manageType
                    if($scope.manageType=='7'){ //乐企平台
                        $scope.queryParam.param.invoiceType = ''
                        $scope.queryParam.param.invoiceSource = ''
                        $scope.customizedConfig.queryForm.forEach((item, index)=>{
                            if(item.type == "fply"){
                                item.selected = false
                                item. isHide = true
                            }
                            if(item.type == "gfxf"){
                                item. isHide = false
                            }
                        })
                    }else {
                        if($scope.queryParam.param.invoiceSource == ''){
                            $scope.queryParam.param.invoiceSource ='0'
                        }
                        if($scope.queryParam.param.invoiceType == ''){
                            $scope.queryParam.param.invoiceType ='61'
                        }
                        $scope.customizedConfig.queryForm.forEach((item, index)=>{
                            if(item.type == "fply"){
                                item. isHide = false
                            }
                            if(item.type == "gfxf"){
                                item.selected = false
                                item. isHide = true
                            }
                        })
                    }
                }

                //查询功能，和表头排序功能
                const queryRedInfo = function queryList() {
                    if(!$scope.queryParam.param.invoiceDateStart && $scope.manageType!='7'){
                        logger.logError('开票日期不能为空')
                        return
                    }
                    const days = utils.DateMinus($scope.queryParam.param.invoiceDateStart, $scope.queryParam.param.invoiceDateEnd)
                    if (days > 31 && $scope.manageType!='7') {
                        logger.logError('开票日期查询跨度不允许超过一个月')
                        return
                    }
                    if($scope.manageType=='7' && $scope.queryParam.param.collection == '2'){ //乐企平台
                        logger.logError('乐企通道暂不支持购方申请红字确认单，如需申请，请切换到电子税局通道或到电子税局操作')
                        $scope.dataList = []
                        return
                    }
                    utils.loading('正在查询，请耐心等待')
                    $scope.queryParam.param.invoiceTypeList=[]
                    $scope.queryParam.param.invoiceStatusList=[]
                    $scope.queryParam.param.invoiceTypeList.push($scope.queryParam.param.invoiceType)
                    if($scope.queryParam.param.invoiceStatus){
                        $scope.queryParam.param.invoiceStatusList.push($scope.queryParam.param.invoiceStatus)
                    }else {
                        if($scope.manageType=='7'){
                            $scope.queryParam.param.invoiceStatusList=['1','4']
                        }else {
                            $scope.queryParam.param.invoiceStatusList=['01','04']
                        }
                    }
                    httpRequest.post_getTax4InvoiceInfo($scope.queryParam).then((res) => {
                        let result = res.data.value
                        $scope.dataList = result.list
                        $scope.totalItems = result.total
                        $scope.queryParam.pageNum = result.pageNum
                        $scope.selectedRows = []
                    })
                    .finally(() => {
                        utils.loaded()
                    })
                }
                setTimeout(function () {
                    $scope.ukeyChange()
                    queryRedInfo()
                }, 100);
                $scope.selectedHandle = function () {
                    queryRedInfo()
                }
                $scope.search = function () {
                    if($scope.queryParam.param.collection == "1"&& $scope.customizedConfig){
                        $scope.customizedConfig.table.forEach((item, index)=>{
                            if(item.type == "gf"){
                                item.selected = true
                            }
                            if(item.type == "xf"){
                                item.selected = false
                            }
                        })
                        $scope.gfShow = true
                        $scope.xfShow = false
                    }
                    if($scope.queryParam.param.collection == "2" && $scope.customizedConfig){
                        $scope.customizedConfig.table.forEach((item, index)=>{
                            if(item.type == "gf"){
                                item.selected = false
                            }
                            if(item.type == "xf"){
                                item.selected = true
                            }
                        })
                        $scope.gfShow = false
                        $scope.xfShow = true
                    }
                    queryRedInfo()
                }
                $scope.pageChanged = function () {
                    queryRedInfo()
                }
                // 同步票据 - 暂时不做
                $scope.synchronous = (item) => {
                    $uibModal
                        .open({
                            template: synchronousTemplate,
                            controller: 'synchronousModal',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-hg',
                            resolve: {
                                items1() {
                                    return item
                                },
                            },
                        })
                        .result.then(
                            () => {},
                            () => {}
                        )
                }
                $scope.previewTheBill = (item) => {
                    item.ukeyId = $scope.queryParam.param.ukeyId
                    $uibModal
                        .open({
                            template: billTemplate,
                            controller: 'billTemplateModal',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-hg-redFrom',
                            resolve: {
                                items1() {
                                    return item
                                },
                            },
                        })
                        .result.then(
                            () => {},
                            () => {}
                        )
                }
                $scope.choose = (item) => {
                    item.ukeyId = $scope.queryParam.param.ukeyId
                    item.invoiceType = $scope.queryParam.param.invoiceType?$scope.queryParam.param.invoiceType:item.invoiceType
                    item.collection = $scope.queryParam.param.collection

                    if(!commercialInvoice(item)){
                        httpRequest.post_initTax4RedConfirmInfo(item).then((res) => {
                            let dataList = res.data.value
                            if(dataList && dataList.ovatTax4RedConfirmDetails.length>0){
                                let data = {
                                    confirmId:dataList.confirmId,
                                    ukeyId:item.ukeyId,
                                }
                                $scope.changeState('inforConfirmTab', data)
                            }else {
                                logger.logError('该发票暂无商品明细信息')
                            }
                        })
                    }
                }
                const commercialInvoice = (item) => {
                    const { invoiceType } = item
                    if (invoiceType == '2' || invoiceType == '51') {
                        logger.logError('您选择的是增值税发票管理系统开具的普通发票，无需申请红字确认单，可由销售方在增值税发票管理系统开具红字发票。')
                        return true
                    }
                    return false
                }
            },
        ],
        link(scope) {
            scope.customizedConfig = STFieldConfig
        },
    }
}

selectTicket.$inject = ['$uibModal', 'httpRequest', 'logger', 'STFieldConfig', '$filter', 'Upload']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/selectTicket/selectTicket.js